import { component } from "picoapp";
import { getHeaderHeights } from "../../utilities/general";

export const sectionAnchoring = component((node: HTMLAnchorElement) => {
  const anchorSectionName = node.dataset.anchorSection;
  const anchorIndex = node.dataset.anchorIndex;
  if (!anchorIndex || !anchorSectionName) return;
  const sectionElement = document.querySelectorAll<HTMLElement>(
    ".shopify-section" + `.section-${anchorSectionName}`
  );
  const setScrollMargin = () => {
    const jumpNav = document.querySelector(".contact-jump-links");
    let offset = getHeaderHeights();
    if (jumpNav) {
      const navHeight = jumpNav.classList.contains("is-stuck")
        ? Math.round(jumpNav.getBoundingClientRect().height)
        : 72;
      offset += navHeight + 8;
    }
    sectionElement[parseInt(anchorIndex)].style.scrollMarginTop = `${offset}px`;
    document.documentElement.style.scrollBehavior = "smooth";
  };

  if (sectionElement) {
    const anchorSectionElement = sectionElement[parseInt(anchorIndex)];
    node.href = "#" + anchorSectionElement.id;
    node.addEventListener("click", setScrollMargin);
  }

  return () => {
    if (sectionElement) {
      node.removeEventListener("click", setScrollMargin);
    }
  };
});
